import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { SEOService } from '@shared/services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TranslateModule
  ]
})
export class App {
  private seoService = inject(SEOService);
  image = environment.LOGIN_IMAGE_URL;
  year = new Date().getFullYear();

  constructor() {
    this.seoService.BTGSEOService.updateMetaDescription('Logue-se ao BTG Pactual Content para melhorar a sua experiência. O melhor ativo é o conhecimento');
    this.seoService.setCustomTag('keywords', 'news, Reuters, BTG Pactual Content');
    this.seoService.setCustomTag('robots', 'noindex, nofollow');
    this.seoService.setCustomTag('canonical', 'https://content.btgpactual.com/noticias');
    this.seoService.setCustomTag('image', 'https://content.btgpactual.com/assets/images/btg-favicon.png');
    this.seoService.setCustomTag('author', 'BTG Pactual Content');
    this.seoService.setCustomTag('publisher', 'BTG Pactual Content');
    this.seoService.setCustomTag('copyright', 'BTG Pactual Content');
    this.seoService.setCustomTag('generator', 'BTG Pactual Content');
  }


}
